import adminCP from './admincp'
import company from './company'
import costing from './costing'
import dashboard from './dashboard'
import driver from './driver'
import driverMobile from './driver-mobile'
import journey from './journey'
import monitoring from './monitoring'
import order from './order'
import partner from './partner'
import price from './price'
import quote from './quote'
import report from './report'
import route from './route'
import schedule from './schedule'
import trip from './trip'
import user from './user'
import vehicle from './vehicle'

export default [
  ...user,
  ...company,
  ...driverMobile,
  ...driver,
  ...vehicle,
  ...partner,
  ...order,
  ...schedule,
  ...costing,
  ...quote,
  ...price,
  ...report,
  ...trip,
  ...journey,
  ...monitoring,
  ...dashboard,
  ...route,
  ...adminCP
] as {
  [key: string]: any
}[]
